import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  data: [],
  totalCommodities: 0,
  avgCompletionScore: 0,
  savedFilters: {},
};

const commodityAnalyticsSummarySlice = createSlice({
  name: "commodityAnalyticsSummary",
  initialState,
  reducers: {
    fetchSummary: (state, action) => {
      state.loading = true;
      state.error = null;
      const { filtersString } = action.payload || {};
      if (filtersString) {
        try {
          state.savedFilters = JSON.parse(filtersString);
        } catch (e) {
          state.savedFilters = {};
        }
      }
    },
    fetchSummarySuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload?.data || [];
      state.totalCommodities = action.payload?.totalCommodities || 0;
      state.avgCompletionScore = action.payload?.avgCompletionScore || 0;
    },
    fetchSummaryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    restoreFilters: (state) => {
      return state;
    },
  },
});

export const { actions, reducer } = commodityAnalyticsSummarySlice;
export const sliceKey = "commodityAnalyticsSummary"; // ✅ Explicit key

